import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=237b46da&scoped=true"
import script from "./Dashboard.js?vue&type=script&lang=js&external"
export * from "./Dashboard.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237b46da",
  null
  
)

export default component.exports